import React from 'react';
import './App.css';

function App() {
  return (
    <div className="app">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-background">
          <div className="texture-overlay"></div>
          <div className="radiating-lines"></div>
          {/* Fela insignia decorations */}
          <img src="/patterns/fela-cowrie.svg" alt="" className="fela-insignia fela-top-right" />
          <img src="/patterns/fela-cowrie.svg" alt="" className="fela-insignia fela-bottom-left" />
        </div>

        <div className="hero-content">
          <div className="logo-container">
            <img 
              src="/nahous_logo.png" 
              alt="Nahous Logo" 
              className="collab-logo nahous-logo"
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
            <img 
              src="/bitaclan_logo.png" 
              alt="Bitaclan Logo" 
              className="collab-logo bitaclan-logo"
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
          </div>

          <div className="hero-title">
            <span className="bitaclan-font large">NAHOUS</span>
            <span className="x-connector">×</span>
            <span className="bitaclan-font large">BITACLAN</span>
          </div>

          <div className="japanese-symbols">
            <span className="kanji">文化</span>
            <span className="kanji-separator">•</span>
            <span className="kanji">芸術</span>
            <span className="kanji-separator">•</span>
            <span className="kanji">未来</span>
          </div>

        </div>
      </section>

      {/* Chess Pattern Section */}
      <section className="chess-section">
        {/* Fela insignia decorations */}
        <img src="/patterns/fela-cowrie.svg" alt="" className="fela-insignia fela-chess-left" />
        <img src="/patterns/fela-cowrie.svg" alt="" className="fela-insignia fela-chess-right" />
        <div className="chess-board">
          {Array.from({ length: 64 }).map((_, i) => {
            const row = Math.floor(i / 8);
            const col = i % 8;
            const isBlack = (row + col) % 2 === 0;
            return (
              <div
                key={i}
                className={`chess-square ${isBlack ? 'black' : 'white'}`}
              >
                <div className="square-texture"></div>
              </div>
            );
          })}
        </div>
        
        <div className="chess-content">
          <h2 className="section-title">THE COLLABORATION</h2>
          <div className="content-grid">
            <div className="content-card">
              <div className="card-number">01</div>
              <h3 className="card-title">NAHOUS</h3>
              <p className="card-text">
                A cultural foundation dedicated to supporting art and creativity 
                across Africa. Fusing African heritage with international luxury 
                and contemporary expression.
              </p>
            </div>
            <div className="content-card">
              <div className="card-number">02</div>
              <h3 className="card-title">BITACLAN</h3>
              <p className="card-text">
                Curating the soundtrack to the culture through unique apparel, 
                accessories, and creative expression. From the past to the future.
              </p>
            </div>
            <div className="content-card">
              <div className="card-number">03</div>
              <h3 className="card-title">THE FUSION</h3>
              <p className="card-text">
                Where African artistry meets contemporary fashion. Where tradition 
                dances with innovation. Where culture finds its voice.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Adire Pattern Section */}
      <section className="adire-section">
        <div className="adire-background">
          <div className="adire-pattern"></div>
          <div className="adire-overlay"></div>
        </div>
        <div className="adire-content">
          <h2 className="adire-title">
            <span className="bubble-text">TRADITION</span>
            <span className="connector-dash">—</span>
            <span className="bubble-text">INNOVATION</span>
          </h2>
          <p className="adire-description">
            Drawing inspiration from the vibrant patterns of Adire textiles and 
            the revolutionary spirit of Fela Kuti, this collaboration weaves 
            together threads of African heritage with the bold aesthetics of 
            contemporary streetwear.
          </p>
        </div>
      </section>

      {/* Product Showcase */}
      <section className="products-section">
        <h2 className="section-title">THE COLLECTION</h2>
        <div className="products-grid">
          <div className="product-card">
            <div className="product-image adire-labubu">
              <div className="image-texture"></div>
              <div className="product-mockup">
                <div className="labubu-silhouette"></div>
                <div className="product-badge">VIRAL</div>
              </div>
              <div className="product-label">ADIRE LABUBU</div>
            </div>
            <div className="product-description">
              <h3 className="product-title">Designer Art Toy</h3>
              <p className="product-text">Limited edition collectible with authentic Adire patterns, cowrie shell accessories, and interchangeable Nigerian textile outfits. Inspired by the 2.3B TikTok views trend.</p>
            </div>
          </div>
          <div className="product-card">
            <div className="product-image watch-straps">
              <div className="image-texture"></div>
              <div className="product-label">WATCH STRAPS</div>
            </div>
            <div className="product-description">
              <h3 className="product-title">Custom Straps</h3>
              <p className="product-text">Quick-release Adire-patterned canvas and leather straps with cowrie shell accents. Fits all major watch brands.</p>
            </div>
          </div>
          <div className="product-card">
            <div className="product-image bucket-hats">
              <div className="image-texture"></div>
              <div className="product-label">BUCKET HATS</div>
            </div>
            <div className="product-description">
              <h3 className="product-title">Reversible Headwear</h3>
              <p className="product-text">Trending streetwear essential with bold Adire patterns. Reversible designs for multiple looks.</p>
            </div>
          </div>
          <div className="product-card">
            <div className="product-image bag-charms">
              <div className="image-texture"></div>
              <div className="product-label">BAG CHARMS</div>
            </div>
            <div className="product-description">
              <h3 className="product-title">Statement Accessories</h3>
              <p className="product-text">Mini Adire art pieces, cowrie clusters, and Fela-inspired insignia. The viral accessory trend of 2025.</p>
            </div>
          </div>
          <div className="product-card">
            <div className="product-image jewelry">
              <div className="image-texture"></div>
              <div className="product-label">JEWELRY</div>
            </div>
            <div className="product-description">
              <h3 className="product-title">Heritage Collection</h3>
              <p className="product-text">Cowrie shell bracelets, Adire-beaded necklaces, and statement earrings with traditional Nigerian motifs.</p>
            </div>
          </div>
          <div className="product-card">
            <div className="product-image tote-bags">
              <div className="image-texture"></div>
              <div className="product-label">TOTE BAGS</div>
            </div>
            <div className="product-description">
              <h3 className="product-title">Premium Canvas</h3>
              <p className="product-text">Sustainable materials featuring exclusive artist collaborations. Lagos meets Hackney street style.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-badge">
            <div className="badge-flower">
              <div className="flower-center"></div>
              <div className="flower-petals">
                <span></span><span></span><span></span><span></span>
              </div>
            </div>
            <div className="badge-text">BITACLAN × NAHOUS</div>
          </div>
          <div className="footer-links">
            <a href="https://bitaclan.com" target="_blank" rel="noopener noreferrer">BITACLAN</a>
            <span className="footer-separator">•</span>
            <a href="https://nahous.com" target="_blank" rel="noopener noreferrer">NAHOUS</a>
            <span className="footer-separator">•</span>
            <a href="https://bitaclan.com/pages/contact" target="_blank" rel="noopener noreferrer">CONTACT</a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;

